import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
/** CSS Files */
import "./MyTeams.scss";
/** Common Components */
import Avatar from "../../components/ui/avatar/Avtar";
import NoDataFound from "../../components/ui/noDataFound/NoDataFound";
import Iconify from "../../layouts/components/iconify/iconify";
import CardSection from "../../components/ui/card/CardSection";
import AvatarGroup from "../../components/ui/avatarGroup/AvatarGroup";
/** Common Services & Data Files */
import { encryptUrlData } from "../../services/CryptoService";
import { getProjectGradient } from "../../lib/getProjectGradient";
/** RTK Query */
import { useLazyGetAssignTeamListByUserIdQuery } from "../../app/services/teamProjectsAPI";

const MyTeams = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  /* State*/
  const [myTeam, setMyTeam] = useState([]);
  // API'S Call
  const [getAssignTeamListByUserId, {
    isLoading: isListLoading,
    isFetching: isListFetching,
    isSuccess: isListSuccess,
    data: myTeamListData,
  },] = useLazyGetAssignTeamListByUserIdQuery();

  //** useEffect's */
  useEffect(() => {
    if (user) {
      let userId = user.userId;
      getAssignTeamListByUserId(userId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (!isListFetching && isListSuccess && myTeamListData) {
      setMyTeam(myTeamListData);
    }
  }, [isListFetching, isListSuccess, myTeamListData]);

  //** Funcation's */
  const handleButtonClick = (team) => {
    if (team?.teamId) {
      navigate(`/myteams/teamOverview/${encryptUrlData(team)}`);
    }
  };

  return (
    <>
      <div className="my-project-card center-top-space">
        <CardSection isContentLoading={isListLoading} cardTitle={"My Team"}>
          {myTeam.length > 0 ? (
            <div className="row">
              {myTeam.map((team, index) => (
                <div className="col-3">
                  <div className="" key={index}>
                    <button
                      className="myteam-card pt-3"
                      onClick={() => handleButtonClick(team)}
                    >
                      <div className="myteam-card-header">
                        <div className="myteam-avatar">
                          <Avatar
                            src=""
                            alt={team.teamName}
                            size="medium"
                            shape="square"
                            gradient={getProjectGradient(team.teamId)}
                          />
                          <div className="myteam-circle active"></div>
                        </div>
                        <div className="myteam-title">
                          <div className="myteam-title">{team.teamName}</div>
                          <div className="myteam-address">
                            {team.responsibleUser}
                          </div>
                        </div>
                      </div>
                      <div className="myteam-card-body">
                        <div>
                          <div className="myteam-title">ToTal Task</div>
                          <div className="myteam-desc">{team.taskCount}</div>
                        </div>
                        <div>
                          <div className="myteam-title">Team Members</div>
                          <div className="myteam-desc">{team.memberCount}</div>
                        </div>
                        <div className="align-items-center">
                          <div className="myteam-title">My Tasks</div>
                          <div className="myteam-desc">
                            <Iconify
                              icon="material-symbols-light:task-outline-rounded"
                              width={16}
                            />
                            {team.mytaskCount}
                          </div>
                        </div>
                      </div>
                      <div className="avatar-group-footer">
                        <AvatarGroup
                          avatars={team.teamMembers
                            .split(", ")
                            .map((member) => ({
                              src: "https://via.placeholder.com/150",
                              alt: member,
                            }))}
                          max={4}
                          size="small"
                          shape="circle"
                        />
                      </div>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <NoDataFound />
          )}
        </CardSection>
      </div>
    </>
  );
};

export default MyTeams;
